import {getFromServerToken, postToServerToken, patchToServerToken} from './fetch'
import { useState, useEffect, useContext } from 'react';
import EventContext from "../store/event-context";

const useListVolunteers = () => {
    const [isLoadingVolunteers, setIsLoading] = useState(false);
    const [volunteersData, setData] = useState();
    const [volunteersServerError, setServerError] = useState(null);
    const [toggleRefresh, setToggleRefresh] = useState(false)
    const eventctx = useContext(EventContext);

    useEffect(() => {
        setIsLoading(true);
        console.log("Refreshing volunteers")
        const fetchData = async () => {
            try {
                const {data, status} = await getFromServerToken(`/events/${eventctx.eventId}/volunteers`)

                if (status !== 200) {
                    setData({})
                    setServerError(JSON.stringify(data));
                } else {
                    const improved = data.map(obj=>({
                        ...obj, 
                        id: obj.sub,
                        admin: (obj.groups.includes('admin')),
                        volunteer: (obj.groups.includes('volunteer')),
                        cgi: (obj.email.includes('cgi.com'))
                    }))
                    console.log("Volunteers: ", improved);
                    setData(improved)
                }
            } catch (error) {
                console.log("FETCH ERROR get volunteer")
                console.log(error)
                setData({})
                setServerError(error);
            }
            setIsLoading(false);
        };

        fetchData();
    }, [toggleRefresh, eventctx.eventId]);

    useEffect( () => {
        localStorage.setItem('volunteers', JSON.stringify(volunteersData))
      }, [volunteersData])

    const refresh = () => {
        setToggleRefresh(!toggleRefresh)
    }

    const addVolunteer = async (name, email) => {
        setIsLoading(true)
        // TODO Validation on email, validation on name
        const body = `{"email": "${email}", "username": "${name}"}`
        try {
            const {data, status} = await postToServerToken(`/events/${eventctx.eventId}/volunteers`, body)
            // TODO - Better if post returns just the updated list instead. Check if possible then we do not have to implement refresh on our side
            if (status !== 200)
            {
                console.log("USER ERROR: ")
                setServerError(data.detail)
                setData({})
            }
            else {
                console.log("Now refreshing")
                refresh()
            }
        } catch (error) {
            console.log("FETCH ERROR add volunteer")
            console.log(error)
            setData({})
            setServerError(error);
        }
        setIsLoading(false);
    }

    const toggleVolunteer = async (username, enable) => {
        setIsLoading(true)
        try {
            const {data, status} = await postToServerToken(`/events/${eventctx.eventId}/volunteers/${username}/${enable ? "enable": "disable"}`, "")
            if (status !== 200) {
                console.log("Toggle failed: ")
                setServerError(data.detail)
            }
            else {
                console.log("Now refreshing inside toggleVolunteer")
                //refresh()
                let updated = volunteersData.map(user => ( 
                    user.username===data.username? {
                        ...user, 
                        'enabled': data['enabled'],
                        'admin': (data['groups'].includes('admin')),
                        'volunteer': (data['groups'].includes('volunteer')),
                        'cgi': (data['email'].includes('cgi.com'))
                    } : user
                ))
                setData(updated)
            }
        } catch (error) {
            console.log("FETCH ERROR toggle volunteer")
            console.log(error)
            setData({})
            setServerError(error);
        }
        setIsLoading(false);
    }

    const makeAdmin = async (username) => {
        setIsLoading(true)
        try {
            const {data, status} = await patchToServerToken(`/events/${eventctx.eventId}/volunteers/${username}`, '{"addGroup": "admin"}')
            if (status !== 200) {
                console.log("changing admin failed: ")
                setServerError(data.detail)
            }
            else {
                console.log("Now refreshing inside makeAdmin")
                //refresh()
                console.log("Data after patchToServerToken: ", data);
                console.log("volunteersData BEFORE updated: ", data);
                let updated = volunteersData.map(user => ( 
                    user.username === data.username? {
                        ...user,
                        'admin': (data['groups'].includes('admin')),
                        'volunteer': (data['groups'].includes('volunteer')),
                        'cgi': (data['email'].includes('cgi.com'))
                     } : user
                ))
                console.log("volunteersData AFTER updated: ", data);
                setData(updated)
            }
        } catch (error) {
            console.log("FETCH ERROR makeAdmin volunteer")
            console.log(error)
            setData({})
            setServerError(error);
        }
        setIsLoading(false);
    }
    return { volunteersData, isLoadingVolunteers, volunteersServerError, refresh, addVolunteer, toggleVolunteer, makeAdmin };
}

export default useListVolunteers
